export interface CCTipoDeTransaccion {
    codigoTipoTransaccion: any;
    descripcion: any;
    operacion: any;
    automatica: any;
    documentoAmpara: any;
    generaComision: any;
    porcentaje: any;
    valorFijo: any;
    operador: any;
    tipoDoc: any;
    imprimeRecibo: any;
}

export class CCTipoDeTransaccion implements CCTipoDeTransaccion {
    constructor(init?: CCTiposDeTransaccionFormValues) {
        Object.assign(this, init);
    }
}

export class CCTiposDeTransaccionFormValues {
    codigoTipoTransaccion: number = 0;
    descripcion: string = "";
    operacion: string = "";
    automatica: string = "";
    documentoAmpara: number = 0;
    generaComision: string = "";
    porcentaje: string = "";
    valorFijo: number = 0;
    operador: number = 0;
    tipoDoc: string = "";
    imprimeRecibo: string = "";

    constructor(CCTipoDeTransaccion?: CCTiposDeTransaccionFormValues) {
        if (CCTipoDeTransaccion) {
            this.codigoTipoTransaccion = CCTipoDeTransaccion.codigoTipoTransaccion;
            this.descripcion = CCTipoDeTransaccion.descripcion || '';
            this.operacion = CCTipoDeTransaccion.operacion || '';
            this.automatica = CCTipoDeTransaccion.automatica || '';
            this.documentoAmpara = CCTipoDeTransaccion.documentoAmpara;
            this.generaComision = CCTipoDeTransaccion.generaComision || '';
            this.porcentaje = CCTipoDeTransaccion.porcentaje || '';
            this.valorFijo = CCTipoDeTransaccion.valorFijo;
            this.operador = CCTipoDeTransaccion.operador;
            this.tipoDoc = CCTipoDeTransaccion.tipoDoc || '';
            this.imprimeRecibo = CCTipoDeTransaccion.imprimeRecibo || '';
        }

    }
}